import type { JSX } from 'react';
import { Link } from 'react-router';

/**
 * The single CTA used by every "check your eligibility" / "get started" button on the landing page
 * and in the header.
 *
 * One component on purpose: the marketing site has three separate buttons that must all land on the
 * same place, and a shared component makes that structural rather than something to keep in sync by
 * hand. {@link ELIGIBILITY_ROUTE} is the only place the target is written down.
 */
export const ELIGIBILITY_ROUTE = '/eligibility';

export function EligibilityCta({
  label,
  size = 'lg',
}: {
  readonly label: string;
  readonly size?: 'lg' | 'sm';
}): JSX.Element {
  const padding = size === 'lg' ? 'px-8 py-3.5 text-base' : 'px-5 py-2 text-sm';
  return (
    <Link
      to={ELIGIBILITY_ROUTE}
      className={`nrx-cta inline-flex w-fit items-center justify-center rounded-full font-semibold ${padding}`}
    >
      {label}
    </Link>
  );
}
